package com.patronat.top.core.navigation

import com.patronat.top.dto.UserRole

enum class DashboardSection {
    DASHBOARD,
    MODERATORS,
    VENUES,
    AI_MODERATION,
    USERS,
    REVIEWS,
    TEAM,
    SETTINGS;

    companion object {
        fun getAvailableSections(role: UserRole): List<DashboardSection> {
            return when (role) {
                UserRole.SUPER_ADMIN -> listOf(DASHBOARD,MODERATORS, VENUES, AI_MODERATION, USERS)
                UserRole.MODERATOR -> listOf(DASHBOARD, VENUES, AI_MODERATION, USERS)
                UserRole.BUSINESS_OWNER -> listOf(DASHBOARD, VENUES, REVIEWS,TEAM)
                UserRole.EMPLOYEE -> listOf(DASHBOARD, VENUES, REVIEWS)
                UserRole.CLIENT -> emptyList()
            }
        }
    }
}